import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions, } from 'mydatepicker';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { GlobalComponent } from "../../global/global.component";
import { FilterSettingsModel, IFilter, GridComponent, PageSettingsModel, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { DataStateChangeEventArgs, SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { GroupPayorList, functionpermission, getMappedCompanyBO, GroupPayorCompanyMappingBO, WhereCondition, sortingObj, GetListBO, columnWidth, ColumnChangeBO } from './payer.model';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { Subject } from 'rxjs';
import { emailValidator } from '../password/password.component';
import { CommonApiService } from 'src/app/commonapiservice';
import { PhoneNumberFormatService } from 'src/app/phone-number-format.service';
import { GeneralService } from 'src/app/service/general.service';
import { EmployeeService } from '../employee/employee.service';
import { log } from 'console';
declare var $: any;
@Component({
  selector: 'app-payer',
  templateUrl: './payer.component.html',
  styleUrls: ['./payer.component.scss'],
})
export class PayerComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('grid') public grid: GridComponent;
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  dropInstance: DropDownList;
  changevalue: boolean = false;
  isSaveorUpdateBoolean: boolean = false;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };
  PayorInitialsList:any=[];
  GroupPayorArray: GroupPayorList[];
  GroupPayor: GroupPayorList = new GroupPayorList();
  companyMappedArray: getMappedCompanyBO[];
  GroupPayorCompanyMapping: GroupPayorCompanyMappingBO = new GroupPayorCompanyMappingBO()
  getMappedCompanyBO: getMappedCompanyBO = new getMappedCompanyBO()
  GroupPayorCompanyMappingNew: GroupPayorCompanyMappingBO;
  I837: any = [];
  P837: any = [];
  TransDiag: any = [];
  isUpdate: boolean = false;
  NewGroupPayer: boolean = false;
  AddGrp: boolean = false;
  GroupForm: FormGroup;
  GroupFormUpdate: FormGroup;
  CompanyGroup: FormGroup;
  format: any = [];
  filterSelect: string = 'GroupName';
  SearchColum: string = 'GroupName';
  OrderColumn: string = 'GroupName';
  SearchText: string = '';
  OrderType: string = 'asc';
  GroupPayorDataList: any = [];
  isDesc: boolean = false;
  p: number = 1;
  pageitems: number = 20;
  Filter_Group: string = '';
  Filter_Payor: string = '';
  fp: functionpermission;
  ICDForm: FormGroup;
  enableTab: boolean = false;
  companyList: any = [];
  GroupPayorlist: any = [];
  companycreate: boolean = false;
  valuechange: any = [];
  public statusList: any = [];
  public filterstatusList: any = [];
  PayerFilter: any = [];
  ListI837: any = '';
  GroupId: any;
  error: any = "";
  showErrorAlert: boolean = false;
  deleteError: any = "";
  deleteAlert: boolean = false;
  comAlert: boolean = false;
  comError: any = ""
  ListSendBO: GetListBO = new GetListBO();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  pagshort: sortingObj = new sortingObj();
  radio: boolean = false;
  saveButton: boolean = false
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  public isinitialLoad: boolean = false;
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  initialPage: PageSettingsModel;
  public filterSettings: object;
  stateList: any = []
  FilterStatus:any;
  constructor(public CommonAPI: CommonApiService, private formBuilder: FormBuilder, public http: HttpClient, public toastrService: ToastrService, public phone: PhoneNumberFormatService, public global: GlobalComponent, public general: GeneralService,
    private employeeService: EmployeeService,) {
    this.global.agencyList();
    this.data = CommonAPI;
    this.GroupForm = this.formBuilder.group({
      Group: new FormControl('', Validators.required),
      Payor: new FormControl('', Validators.required),
      Billingfullname: new FormControl(''),
      Address1: new FormControl(''),
      Address2: new FormControl(''),
      City: new FormControl(''),
      State: new FormControl(''),
      Zip: new FormControl(''),
      Phonenumber: new FormControl(' ', [Validators.minLength(14), Validators.maxLength(14)]),
      PayorEmail: new FormControl('', Validators.compose([Validators.email, emailValidator])),
      BillType: new FormControl(''),
      BillingPayorID: new FormControl('', Validators.required),
      MC: new FormControl(''),
      ExcelLid: new FormControl(''),
      format: new FormControl(''),
      InsID: new FormControl('', Validators.required),
      IInsID: new FormControl(''),
      Trans: new FormControl(''),
      ATYPICAL: new FormControl(''),
      Waiverflag: new FormControl(''),
      Description: new FormControl(''),
      PayorInitials: new FormControl(''),
      status:new FormControl('',Validators.required)
    });
    this.CompanyGroup = this.formBuilder.group({
      providerNo: new FormControl(" ", Validators.required),
      companyFEIN: new FormControl(" ", [Validators.required, Validators.minLength(9), Validators.maxLength(9)]),
      claim_Filling_Ind: new FormControl("	", Validators.required),
      taxCode_MANo: new FormControl(" "),
      taxCode_MCNo: new FormControl(" "),
    });
  }
  ngOnInit() {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    this.CommonAPI.getStateJson().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.fp = new functionpermission();
    this.filepermissionget();
    this.filterSettings = { type: 'Menu' };
  //  let pag = JSON.parse(this.global.globalColumn.column)[0]?.Grouppayor.Pagesize;
    let pag = 10;
    this.initialPage = {
      currentPage: 1,
      pageSizes: this.pageSizes,
      pageSize: pag,
    };
    this.getBillingStatus();
    this.getPayorInitials();
    this.getI837();
    this.getP837();
    this.getformat();
    this.getStatusDrop();
    this.fp = new functionpermission();
    this.filepermissionget();
  }
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "payorName";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Grouppayor.Pagesize != state.take) {
          this.arraycol[0].Grouppayor.Pagesize = state.take
          this.SaveColumnwidth();


        }

      }
    }

    this.getGroupPayor();
  }

  onActionBegin(args) {

  }

  public onActionComplete(args) {
    this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;

    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ListSendBO.type = args.columnType
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })

      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {

        this.arraycol[0].Grouppayor.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });

        });

        this.arraycol[0].Grouppayor.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });

        });


        if (this.arraycol[0].Grouppayor.ShowColumns.length != count1 || this.arraycol[0].Grouppayor.HideColumns.length != count) {
          this.arraycol[0].Grouppayor.ShowColumns = showarr;
          this.arraycol[0].Grouppayor.HideColumns = hidearr;
          this.SaveColumnwidth();
        }
      }
    }
  }
  reset_filter() {
    this.radio = false

  }
  //////////////////Assign Company/////////////////////////////////
  assigncompanyTable() {
    this.GroupPayorCompanyMapping.taxCode_MANo = null;
    this.GroupPayorCompanyMapping.taxCode_MCNo = null;
    this.GroupPayorCompanyMapping.claim_Filling_Ind = null
    // this.GroupPayorCompanyMapping.companyFEIN = null
    this.getMappedCompanyList();
    this.valueschanges();
  }
  ////////////////////////////////Show table view after Cancel click///////////////////////////////
  showtable() {
    this.isUpdate = false;
    this.AddGrp = false;
  }
  getGroupPayor() {
    let url = "api/Payer/GetGroupPayorFilterList?"
    let responseData =
    {
      result: "lList",
      count: "totalCount",
    }
    this.ListSendBO.statusLid=this.FilterStatus?.toString()
    this.CommonAPI.outputValues(url, this.ListSendBO, responseData, "");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GroupPayorDataList = data.result;
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
        if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
          // this.getColumnwidth();
        }
      }
      if (data != null && data.result.length > 15) {
        this.grid.height = '500';
      }
      else {
        this.grid.height = 'auto';
      }
    })
  }
  /////////////////////////Filter Functions/////////////////////////////////
  onKeydown(event, filter) {
    if (event.key === "Enter") {
      this.p = 1;
      this.Search(filter);
      this.getGroupPayor();
    }
  }
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  selected_filter(filter) {
    this.SearchColum = filter;
  }
  change_group(event) {
    this.Filter_Group = event.target.value;
    this.SearchText = event.target.value;
  }
  Search(filter) {
    this.ListSendBO.field = (this.filterSelect != null && this.filterSelect != undefined && this.filterSelect != '') ? this.filterSelect : "payorName";
    if (filter == this.Filter_Group) {
      this.ListSendBO.value = this.Filter_Group;
    }
    else if (filter == this.Filter_Payor) {
      this.ListSendBO.value = this.Filter_Payor;
    }
    this.getGroupPayor();
  }
  refreshToGetDropDownValues(ListCode: string) {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", ListCode);
    this.CommonAPI.RefreshDropDownList(ListCode, params, url, "LovDropDown").then((data: any) => {
      if (ListCode == 'STATUS') {
        this.statusList = data;
      }
      if (ListCode == 'GROUP') {
        this.GroupPayorlist = data;
        this.GroupPayorlist.forEach(element => {
          element.label = element.lovName;
          element.value = element.id.toString();
        });
      }
      if (ListCode == 'I837') {
        this.I837 = data;
        this.I837.forEach(element => {
          element.label = element.lovName;
          element.value = element.id.toString();
        });
      }

      if (ListCode == 'PAYERINITIALS') {
        this.PayorInitialsList = data;
        this.PayorInitialsList?.forEach(element => {
          element.label = element.lovName;
          element.value = element.id.toString();
        });
      }
    })
  }
  ////////////////////////

    //..................................................getEmployeeStatus........................................
    getStatusDrop() {
      let params = new URLSearchParams();
      params.append("ListCode", "STATUS");
      this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        const status = [...data]; // Create a shallow copy of data
this.filterstatusList = [...data]; // Create another shallow copy of data
let values = {
  "id": '00000000-0000-0000-0000-000000000000',
  "lovName": "ALL",
  "lovCode": "ALL",
  "lovValue": "ALL"
};
this.filterstatusList.push(values);
this.statusList = status;
      
    
      
      this.FilterStatus = this.statusList?.filter(
        (st) => st.lovName == "Active"
      )[0].id;
      this.getGroupPayor();
    }, err => {
    })
    }
  getStatusLov() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.CommonAPI.getDropDownList('STATUS', params, url, "LovDropDown").then((data: any) => {
      this.statusList = data;
      this.statusList.push({ Key: '0', Value: "All" });
      this.FilterStatus = this.statusList?.filter(
        (st) => st.Value == "Active"
      )[0].Key;
      this.getGroupPayor();
    }, err => {
    })
  }

  ///////////////////Update Company///////////////////////////////////
  updateCom(Co_list) {
    console.log(Co_list,"Co_list=======");
    
    this.GroupPayorCompanyMapping = Co_list;
    this.companycreate = false;
  }
  ///////////////////Delete Company///////////////////////////////////
  DeleteCom(Co_list) {
    this.GroupPayorCompanyMapping = Co_list;
  }
  /////////////////////////save company details/////////////////////////
  saveCompany(list) {
    this.isSaveorUpdateBoolean=true;
    list = JSON.parse(JSON.stringify(list));
    list.statusLid = parseInt(list.statusLid);
    let url = "api/PayorCompanyMap/SaveGroupPayorCompanyMapping";
    let obj;
    if (this.companycreate == true) {
      obj = {
        companyId: this.GroupPayorCompanyMapping.id,
        groupPayorId: this.GroupPayor.id,
        companyFEIN: list.companyFEIN,
        claim_Filling_Ind: list.claim_Filling_Ind,
        providerNo: list.providerNo,
        taxCode_MANo: list.taxCode_MANo,
        taxCode_MCNo: list.taxCode_MCNo
      }
    }
    else {
      obj = list;
    }
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    this.http.post(url, JSON.stringify(obj), httpOptions).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.isSaveorUpdateBoolean=false;
      list.id = data;
      document.getElementById('openModal4').click()
      this.companycreate = false
      this.toastrService.success('Company updated successfully!')
      this.getMappedCompanyList();
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.comError = err.error;
        this.comAlert = true
      }
      else {
        this.comError = JSON.stringify(err.error);
      }
      if (this.comError != "") {
        setTimeout(() => {
          this.comError = "";
          this.comAlert = false
        }, 5000)
      }
    })
  }
  ///////////////////////////////////Billing Status Dropdown///////////////////////////////////
  getBillingStatus() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "PAYER");
   
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GroupPayorlist = data;
      this.GroupPayorlist?.forEach(element => {
        element.label = element.lovName;
        element.value = element.id.toString();
      });
  }, err => {
  })
  }
  getPayorInitials() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "PAYERINITIALS");
   

    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.PayorInitialsList = data;
      this.PayorInitialsList?.forEach(element => {
        element.label = element.Value;
        element.value = element.Key.toString();
      });
  }, err => {
  })
  }

  /////////////////////////////////////////refresh////////////////////////////////////////
  refresh() {
    this.pageitems = 20;
    this.OrderType = "asc";
    this.filterSelect = '';
    this.SearchText = '';
    this.Filter_Group = '';
    this.Filter_Payor = '';
    this.p = 1;
    this.ListSendBO.field = "payorName"
    this.ListSendBO.value = ''
    this.getGroupPayor();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  ///////////////////////////// get list of Company Details////////////////////////
  getCompany() {
    let url = "api/Company/getCompanyPayorList?";
    let params = new URLSearchParams();
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: getMappedCompanyBO[]) => {
      this.companyList = data;
    })
  }
  /////////////////////////// Assign Company //////////////////////////////////
  assignCompanyPayor() {
    let url = "api/PayorCompanyMap/SaveGroupPayorCompanyMapping";
    let obj = {
      companyId: this.GroupPayorCompanyMapping.id,
      groupPayorId: this.GroupPayor.id,
      providerNo: JSON.stringify(this.CompanyGroup.get('providerNo').value),
      companyFEIN : JSON.stringify(this.CompanyGroup.get('companyFEIN').value)
    }
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    this.http.post(url, JSON.stringify(obj), httpOptions).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.getMappedCompanyList();
    })
  }
  //////////////////////////////Company map List///////////////////////////////
  getMappedCompanyList() {
    let params = new URLSearchParams();
    params.append("grouppayorId", this.GroupPayor.id.toString());
    let url = "api/PayorCompanyMap/GetGroupPayorCompanyMappingList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.companyMappedArray = data;
    })
  }
  ////////////////////////Select Company///////////////////////////////////////////////
  selectCompany(event, selectedData) {
    document.getElementById('companymodal').click()
    console.log(selectedData,"selectedData================");
    
    this.GroupPayorCompanyMapping = selectedData;
    this.GroupPayorCompanyMapping.companyFEIN = selectedData.feiN_MCNo;
    this.companycreate = true;
    selectedData.checked = false
  }
  ////////////////////////////get Payor Dropdown///////////////////////////////
  getGroupPayor_dropdown() {
    let url = "api/Payer/GetGroupPayorList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.PayerFilter = data;
    })
  }
  /////////////////////////////get i837 Dropdown//////////////////////////
  getI837() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "I837PINSURANCETYPE");
  
      this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.I837 = data;
        this.I837?.forEach(element => {
          element.label = element.lovName;
          element.value = element.id.toString();
        });
      },
        (err: any) => {
          this.ListI837 = "";
          this.ListI837 = JSON.stringify(err);
          if (this.ListI837 != "") {
            setTimeout(() => {
              this.ListI837 = "";
            }, 8000)
          }
        });
      
  }
  //////////////////////// number only input for zipcode///////////////////// 
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  //////////////////////// getP837 dropdown///////////////////// 
  getP837() {
    let url = 'api/LOV/GetLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "I837");
  
      this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.P837 = data;
      },
        (err: any) => {
          if (err) {
            this.ListI837 = JSON.stringify(err);
          }
          else {
            this.ListI837 = JSON.stringify(err);
          }
          if (this.ListI837 != "") {
            setTimeout(() => {
              this.ListI837 = "";
            }, 8000)
          }
        });
      
  }
  ////////////////////////group payor create and edit///////////////////// 
  GrpCreateupdate(type: string,data) {
    if (type == 'new') {
      this.AddGrp = true;
      this.GroupForm.reset();
      this.enableTab = false;
      this.GroupPayor = new GroupPayorList();
      this.companyMappedArray = null;
      this.GroupPayor.statusLid="Active"
      this.GroupForm.get('status').setValue(this.GroupPayor.statusLid);
    }
    else if (type == 'edit') {
      this.isUpdate = true;
      this.getMappedCompanyList()
      this.enableTab = true;
      this.AddGrp = false;
      console.log(this.GroupPayor.statusLid,"this.GroupPayor.statusLid");
      
      // this.GroupPayor.statusLid=this.statusList?.filter(
      //   (st) => st.id == data.statusLid
      // )[0].Value;
      // this.GroupForm.get('status').setValue(this.GroupPayor.statusLid);
    }    
    this.valueschanges()
  }
  selectgrpdetails(Details: GroupPayorList) {
    this.GroupPayor = Details;
    this.GroupPayor = JSON.parse(JSON.stringify(Details));
    this.getCompany();
  }
  ////////////////////////group payor save and Update///////////////////// 
  SaveOrUpdateGroupPayor() {
    this.isSaveorUpdateBoolean=true;
    var listParam: GroupPayorList = JSON.parse(JSON.stringify(this.GroupPayor));
    listParam.i837PInsTypeLid = this.GroupForm.get('InsID').value;
    listParam.groupLid = this.GroupForm.get('Group').value;

    listParam.payerInitialLid =( this.GroupPayor.payerInitialLid!='00000000-0000-0000-0000-000000000000'
       && this.GroupPayor.payerInitialLid!=null && this.GroupPayor.payerInitialLid!="")?this.GroupForm.get('PayorInitials').value:null;
 
  
    
    listParam.statusLid = this.statusList.filter(ele=>ele.id==listParam.statusLid)[0].id;
    let url = "api/Payer/SaveGroupPayor";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(listParam, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.enableTab = true
      this.isSaveorUpdateBoolean=false;
      if (this.isUpdate) {
        this.showtable();
        this.AddGrp = false;
        this.isUpdate = false
        this.GroupPayor.id = data.id;
        this.toastrService.success('Group payor updated successfully!')
        this.getStatusDrop();     
       }
      else if (this.AddGrp) {
        this.GroupPayor.id = data.id;
        this.toastrService.success('Group payor saved successfully!')
        this.getStatusDrop();     
        this.getCompany();
        this.isUpdate = true;
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.error = err;
        this.showErrorAlert = true
      }
      else {
        this.error = JSON.stringify(err);
      }
      if (this.error != "") {
        setTimeout(() => {
          this.error = "";
          this.showErrorAlert = false
        }, 3000)
      }
    })
  }
  //////////////////////// delete group payor///////////////////// 
  GroupDelete(listParam) {
    this.GroupPayor.id = listParam.id;
  }
  deleteGroup() {
    let url = "api/Payer/DeleteGroupPayor?";
    let params = new URLSearchParams();
    params.append("GroupId", this.GroupPayor.id.toString());
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success('Group payor deleted successfully!')
      this.getGroupPayor();
    }, (err: any) => {
      if (err) {
        this.deleteError = err;
        this.deleteAlert = true
      }
      else {
        this.deleteError = JSON.stringify(err);
      }
      if (this.deleteError != "") {
        setTimeout(() => {
          this.deleteError = "";
          this.deleteAlert = false
        }, 5000)
      }
    }
    )
  }
  deleteGroupCompanyMapping() {
    let params = new URLSearchParams();
    params.append("CompanyId", this.GroupPayorCompanyMapping.id.toString());
    let url = "api/PayorCompanyMap/DeleteGroupPayorCompany?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Mapped Company deleted successfully!")
      this.getMappedCompanyList();
    }, (err: any) => {
      if (err) {
        this.error = err;
        this.showErrorAlert = true
      }
      else {
        this.error = JSON.stringify(err);
      }
      if (this.error != "") {
        setTimeout(() => {
          this.error = "";
          this.showErrorAlert = false
        }, 5000)
      }
    }
    )
  }
  valueschanges() {
    this.valuechange = {
      Group: 0,
      Payor: 0,
      Billingfullname: 0,
      Address1: 0,
      Address2: 0,
      City: 0,
      State: 0,
      Phonenumber: 0,
      PayorEmail: 0,
      BillType: 0,
      BillingPayorID: 0,
      format: 0,
      InsID: 0,
      ATYPICAL: 0,
      Waiverflag: 0,
    }
  }
  //......................................changefunction.....................................
  changefunction() {
    this.changevalue = true;
  }
  cancel() {
    if (this.changevalue == true && (this.GroupPayor.id=='00000000-0000-0000-0000-000000000000'||this.GroupPayor.id==null||this.GroupPayor.id==undefined)){
      document.getElementById("openModal2").click();
    } else {
      this.showtable();
      this.getGroupPayor();
    }
  }
  cancelYes() {
    this.showtable()
    this.changevalue = false;
    document.getElementById('openModal2').click()
     this.getStatusDrop();     
    
  }
  check() {
    if (this.AddGrp) {
      if (this.GroupForm.valid) {
        this.SaveOrUpdateGroupPayor();
      }
    }
    else if (this.isUpdate) {
      if (this.GroupFormUpdate.valid) {
        this.SaveOrUpdateGroupPayor();
      }
    }
  }
  //////////////////// phone num format//////////////////////////////////
  formatPhoneNumber(event, phonenum) {
    if (event.which < 48 || event.which > 57) {
      event.preventDefault();
    }
    this.GroupPayor.phoneNumber = this.phone.getPhoneNumberFormat(phonenum);
  }
  PhoneFormat() {
    this.GroupPayor.phoneNumber = this.general.converPhoneGoogleLib(this.GroupPayor.phoneNumber);
  }
  filepermissionget() {
    let params = new URLSearchParams();
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    params.append("pagecode", "GroupPayor");
    // params.append("roleId", this.global.roleId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: any) => {
        this.fp = new functionpermission();
      })
  }
  getTransDiag() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "TRANSCODE");
    this.CommonAPI.getDropDownList('TRANSCODE', params, url, "LovDropDown").then((data: any) => {
      this.TransDiag = data;
    })
  }
  getformat() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "FORMAT");
 
      this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.format = data;
      },
        (err: any) => {
          if (err) {
            this.ListI837 = JSON.stringify(err);
          }
          else {
            this.ListI837 = JSON.stringify(err);
          }
          if (this.ListI837 != "") {
            setTimeout(() => {
              this.ListI837 = "";
            }, 8000)
          }
        });
      
  }
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Grouppayor.Columns;
    this.grid.columns.forEach(col => {
      this.arraycol[0].Grouppayor.HideColumns.forEach(element => {
        if (col.headerText == element) {
          col.visible = false;
        }
      });
    });
    this.grid.hideColumns(this.arraycol[0].Grouppayor.HideColumns);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].Grouppayor.Pagesize
    this.ColumnArray.forEach(element => {
      if (element.column == 'Group') {
        const column = this.grid.getColumnByField('groupName');
        column.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Payor') {
        const column1 = this.grid.getColumnByField('payorName');
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Address') {
        const column2 = this.grid.getColumnByField('addressLine1');
        column2.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'City') {
        const column3 = this.grid.getColumnByField('city');
        column3.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'State') {
        const column4 = this.grid.getColumnByField('state');
        column4.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Zip') {
        const column5 = this.grid.getColumnByField('zip');
        column5.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Phone number') {
        const column6 = this.grid.getColumnByField('phoneNumber');
        column6.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Bill Type') {
        const column7 = this.grid.getColumnByField('defaultBillType');
        column7.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Payor Initials') {
        const column7 = this.grid.getColumnByField('payerInitialName');
        column7.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Payor ID') {
        const column8 = this.grid.getColumnByField('payorId');
        column8.width = element.width;
        this.grid.refreshHeader();
      }
      else if (element.column == 'Actions') {
        const column9 = this.grid.getColumnByUid('Actions');
        column9.width = element.width;
        this.grid.refreshHeader();
      }
    });
  }
  SaveColumnwidth() {
    // this.arraycol[0].Grouppayor.Columns = this.ColumnArray;
    // this.arraycol[0].Grouppayor.Pagesize = this.grid.pageSettings.pageSize;
    // this.columnchange.userid = parseInt(this.global.userID);
    // this.columnchange.column = JSON.stringify(this.arraycol);
    // this.columnchange.id = this.id;
    // this.global.globalColumn = this.columnchange;
    // this.arraycol = JSON.parse(this.global.globalColumn.column);
    // let url = "api/ColumnChange/Savewidth?";
    // this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //   this.getColumnwidth();
    // });
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

